import React from 'react';
import c from '../w.js';

const IconFilePresentation = React.memo(
  c(
    /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("path", { d: "M14 3.00009C14 2.4478 14.45 1.99353 14.998 2.06173C18.6183 2.51226 21.4878 5.38176 21.9384 9.00207C22.0066 9.55013 21.5523 10.0001 21 10.0001H15C14.4477 10.0001 14 9.55237 14 9.00009V3.00009Z" }), /* @__PURE__ */ React.createElement("path", { d: "M18 13.0001C18.5523 13.0001 19.0066 13.45 18.9384 13.9981C18.4471 17.9454 15.0803 21.0001 11 21.0001C6.58172 21.0001 3 17.4184 3 13.0001C3 8.91978 6.05471 5.55295 10.002 5.06173C10.55 4.99353 11 5.4478 11 6.00009V12.0001C11 12.5524 11.4477 13.0001 12 13.0001H18Z" }))
  )
);

export { IconFilePresentation };
